module.exports = __webpack_public_path__ + "static/media/homepage-overlay-2.4f914baf.webp";